// extracted by mini-css-extract-plugin
export default {"SubcatgoryForm":"Subcatgory_SubcatgoryForm__UOocL"};